import ocaml from "refractor/ocaml";
export default ocaml;